export default "__VITE_ASSET__DKSiBDZX__"